import { formatSecondsDuration, get_formated_time, replaceUnderscoresWithSpaces } from '../../../utils/commonFunctions'
import CustomToolTip from '../CustomToolTip'
import { DefinedFaultTask } from '../../simulate/my-scenario/utils/scenario-types'
import './FaultOverlay.scss'
import { formatExecDurationValue } from './helperFunction'
import { OverlayTrigger } from 'react-bootstrap'

const FaultOverlay = ({ Events }: { Events: DefinedFaultTask[] }) => {
    return (
        <div className="fault__overLay__container">
            {Events.map((event, index) => {
                const execReq = event.executionRequirement;
                const execDurationText = formatExecDurationValue(execReq?.duration)
                const faultDurationText = formatSecondsDuration(event?.duration, { hideZero: true })
                const durationsMatch = Boolean(execDurationText && faultDurationText && execDurationText === faultDurationText)
                const durationTooltipText = (durationsMatch && execDurationText) ? execDurationText : (execDurationText && faultDurationText) ? `${execDurationText} → ${faultDurationText}` : faultDurationText ?? execDurationText ?? null;
                const duration = faultDurationText || durationTooltipText ? faultDurationText ?? durationTooltipText : null
                const displayDetails = event.faultDetails?.display || {}
                const faultName = replaceUnderscoresWithSpaces(event?.['faultName'])
                const system = replaceUnderscoresWithSpaces(event.faultSystem || 'Unknown')
                const uniqueKey = `fault-${index}`
                return (
                    <div className="fault__overLay__card" key={uniqueKey}>
                        <OverlayTrigger
                            key={uniqueKey}
                            placement="auto"
                            overlay={
                                <div className='fault__overLay__card__body'>
                                    <div className='d-flex w-100 align-items-center justify-content-between'>
                                        <div className='card_info'>
                                            <span className='fs-13'>{event?.['startTime'] && get_formated_time(event?.['startTime'])} UTC</span>
                                            <span className='fs-12 opacity-50'>Start Time</span>
                                        </div>
                                        <div className='card_info align__end'>
                                            <span className='fs-13'>{event?.['startTime'] && get_formated_time(event?.['endTime'])} UTC</span>
                                            <span className='fs-12 opacity-50'>End Time</span>
                                        </div>
                                    </div>
                                    <div className='d-flex w-100 align-items-center justify-content-between flex-wrap gap-2'>
                                        {duration &&
                                            <div className='card_info'>
                                                <span className='fs-13'>{duration}</span>
                                                <span className='fs-12 opacity-50'>Duration</span>
                                            </div>
                                        }
                                        {Object.entries(displayDetails).map(([key, value], index) => {
                                            const oddIndex = duration ? index % 2 === 0 : index % 2 === 1
                                            const align = oddIndex ? 'align__end' : ''
                                            return (
                                                <div className={`card_info ${align}`} key={index}>
                                                    <span className='fs-13'>{replaceUnderscoresWithSpaces(String(value))}</span>
                                                    <span className='fs-12 opacity-50'>{replaceUnderscoresWithSpaces(key)}</span>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            }
                        >
                            <div className='fault__overLay__card__header'>
                                <div className='d-flex flex-column align-items-start w-50'>
                                    <span className='w-98 text-truncate fs-13'>
                                        <CustomToolTip title={faultName}>{faultName}</CustomToolTip>
                                    </span>
                                    <span className='fs-12 opacity-50'>Fault Name</span>
                                </div>
                                <div className='d-flex flex-column align-items-end w-50'>
                                    <span className='fs-13 text-truncate w-98 text-end'>
                                        <CustomToolTip title={system}>
                                            {system}
                                        </CustomToolTip>
                                    </span>
                                    <span className='fs-12 opacity-50'>System</span>
                                </div>
                            </div>
                        </OverlayTrigger>
                    </div>
                )
            })}
        </div>
    )
}

export default FaultOverlay